<ejs-dialog 
  target=".dialogs" 
  class="steps-dialog" 
  [visible]='visible' 
  [animationSettings]='dialogService.getAnimationSettings()' 
  [resizeHandles]='dialogService.getResizeHandleDirection()' 
  [position]='dialogService.getPosition()' 
  [isModal]="true" 
  [allowDragging]="false"
  [width]="'60%'" 
  [height]="'60vh'" 
  [zIndex]="999" 
  [showCloseIcon]="true"
  (close)="close()">
  <ng-template #header class="p-1">
    <div class="d-flex justify-content-between align-items-center p-2">
      <div class="share-dialog-header-title">
        <app-headline [title]="'SHAREPOSTTITLE' | translate" [type]="'h5'"></app-headline>
      </div>
      <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close d-none d-md-block'"></app-form-button>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex h-100">
      <div class="col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
        <!-- Share type selection -->
        <div class="d-none d-md-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <app-headline [title]="'SHAREPOSTTITLE' | translate" [type]="'h5'"></app-headline>
          </div>
          <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close d-none d-md-block'"></app-form-button>
        </div>
        <div class="mb-3">
          <app-form-label [label]="'SELECTSHAREMETHOD' | translate"></app-form-label>
          <app-form-dropdown
            [fG]="shareMethodForm"
            [fCN]="'method'"
            [dataSource]="shareMethodOptions"
            [placeholder]="'SELECT' | translate"
            (valueChange)="onShareMethodChange($event)"
          >
          </app-form-dropdown>
        </div>
        <!-- Share type titles -->
        @if (activeStepKey !== null) {
          <div class="d-flex align-items-center mb-3">
            <app-headline [title]="steps[activeStep!]" [type]="'h5'"></app-headline>
            <div class="ms-2">
              <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('SHAREHELP' + activeHelpStepIndex | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
            </div>
          </div>
          <div
            class="custom-scrollbar overflow-y-auto"
            (scrollend)="layoutService.setScrollToEnd($event, 'share-page-' + activeStep)"
            >
            <form class="p-1 d-flex flex-column h-100">
              @switch (activeStepKey) {
              @case ('news') {
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSRECIPIENTSSECTIONTITLE' | translate"
                  >
                </app-headline>
                <app-form-label class="my-2" [label]="'NEWSEDITRECIPIENTS' | translate"></app-form-label>
                <div class="mb-2">
                  @if (canCreateForAllRecipients()) {
                    <app-form-radio
                      [fG]="shareNewsForm"
                      [fCN]="'recipients'"
                      [value]="'all'"
                      [placeholder]="'NEWSEDITRECIPIENTSALL' | translate"
                      [cssClass]="'e-normal'"
                      >
                    </app-form-radio>
                  }
                  @if (shareNewsForm.controls['recipients'].value === 'all' && canCreateForAllRecipients()) {
                    <div class="mt-2 form-check">
                      <app-form-checkbox
                        [fG]="shareNewsForm"
                        [fCN]="'is_recipients_all_push'"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'NEWSEDITRECIPIENTSALLPUSH' | translate"
                        >
                      </app-form-checkbox>
                    </div>
                  }
                </div>
                <div class="mb-2">
                  @if (canCreateForSelectionRecipients()) {
                    <app-form-radio
                      [fG]="shareNewsForm"
                      [fCN]="'recipients'"
                      [value]="'selection'"
                      [placeholder]="'NEWSEDITRECIPIENTSSELECTION' | translate"
                      >
                    </app-form-radio>
                  }
                  @if (shareNewsForm.controls['recipients'].value !== 'all' && canCreateForSelectionRecipients()) {
                    <div class="mt-2">
                      <app-form-user-group-mail
                        [allowEmails]="false"
                        [allowPush]="true"
                        [method]="canCreateForUserRecipients() && canCreateForGroupRecipients() ? 'userGroup' : (canCreateForUserRecipients() ? 'user' : 'group')"
                        [hasError]="isUserGroupSelectionError"
                        [(user)]="participantsUserIDs"
                        [(groups)]="participantsGroupIDs"
                        [can]="'news'"
                        (userChange)="participantsUserIDs = $event; shareNewsForm.controls['participantsUserIDs'].setValue($event); isUserGroupSelectionError = false"
                        (groupsChange)="participantsGroupIDs = $event; shareNewsForm.controls['participantsGroupIDs'].setValue($event); isUserGroupSelectionError = false"
                        (pushUserIDsChange)="pushUserIDs = $event; shareNewsForm.controls['pushUserIDs'].setValue($event)"
                        (pushGroupIDsChange)="pushGroupIDs = $event; shareNewsForm.controls['pushGroupIDs'].setValue($event)"
                        >
                      </app-form-user-group-mail>
                    </div>
                  }
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSCONTENTSECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="my-2">
                  <app-form-label
                    [label]="'SHARENEWSTITLELABEL' | translate"
                    [maxChars]="100"
                    [currentChars]="shareNewsForm.controls['title'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHARENEWSTITLEPLACEHOLDER' | translate)"
                    [label]="('SHARENEWSTITLELABEL' | translate)"
                    [errorText]="('SHARENEWSTITLEREQUIRED' | translate)"
                    [fCN]="'title'"
                    [fG]="shareNewsForm"
                    [maxChars]="100"
                    >
                  </app-form-input>
                </div>
                <div class="mb-3">
                  <app-form-label
                    [label]="'SHARENEWSMESSAGEPLACEHOLDER' | translate"
                    [maxChars]="10000"
                    [currentChars]="getNewsMessageCharCount()"
                    >
                  </app-form-label>
                  <app-form-textarea
                    [fCN]="'message'"
                    [fG]="shareNewsForm"
                    [errorText]="getNewsMessageErrorText()"
                    [rows]="4"
                    [richText]="true"
                    [showCharCounter]="false"
                    [maxChars]="10000"
                    [style]="'block'"
                    >
                  </app-form-textarea>
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSMEDIASECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="mt-2 mb-3">
                  <app-form-label
                    [label]="'SHARENEWSMEDIATOEDIT' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-wrap gap-2">
                    <app-document-selector
                      [files]="selectableNewsFiles()"
                      (selectedFiles)="shareNewsForm.controls['files'].setValue($event)"
                      >
                    </app-document-selector>
                  </div>
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSTIMINGSECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="my-2">
                  <app-form-label
                    [label]="'SHARENEWSSTARTDATETITLE' | translate"
                    >
                  </app-form-label>
                  <app-form-date-time
                    [fG]="shareNewsForm"
                    [fCN]="'startDate'"
                    [cssClass]="isStartDateFutureInvalid() || isEndDateOrderInvalid() ? 'e-error' : ''"
                    [placeholder]="'SHARENEWSSTARTDATEPLACEHOLDER' | translate"
                    >
                  </app-form-date-time>
                  @if (isStartDateFutureInvalid()) {
                    <div class="e-error mt-1">{{ getStartDateErrorMessage() }}</div>
                  }
                </div>
                <div class="mb-3">
                  <app-form-label
                    [label]="'SHARENEWSENDDATETITLE' | translate"
                    >
                  </app-form-label>
                  <app-form-date-time
                    [fG]="shareNewsForm"
                    [fCN]="'endDate'"
                    [cssClass]="hasSchedulingError() ? 'e-error' : ''"
                    [placeholder]="'SHARENEWSENDDATEPLACEHOLDER' | translate"
                    >
                  </app-form-date-time>
                  @if (hasSchedulingError()) {
                    <div class="e-error mt-1">{{ getSchedulingErrorMessage() }}</div>
                  }
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSSETTINGSSECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="mt-2 mb-3">
                  <app-form-label
                    [label]="'SHARENEWSSETTINGSTITLE' | translate"
                    >
                  </app-form-label>
                  <app-form-label
                    [label]="'NEWSEDITCOMMENTSALLOWED' | translate"
                    class="mt-2"
                    >
                  </app-form-label>
                  <div class="d-flex flex-row flex-wrap gap-2">
                    <div class="m-2">
                      <app-form-checkbox
                        [fG]="shareNewsForm"
                        [fCN]="'allowComments'"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'NEWSEDITMARKCOMMENTSALLOWED' | translate"
                        >
                      </app-form-checkbox>
                    </div>
                  </div>
                  <app-form-label
                    [label]="'NEWSEDITPUBLICSHARINGALLOWED' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-row flex-wrap gap-2">
                    <div class="m-2">
                      <app-form-checkbox
                        [fG]="shareNewsForm"
                        [fCN]="'allowSharing'"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'NEWSEDITMARKPUBLICSHARINGALLOWED' | translate"
                        >
                      </app-form-checkbox>
                    </div>
                  </div>
                  <app-form-label
                    [label]="'NEWSISIMPORTANT' | translate"
                    class="ml-2 mt-2"
                    >
                  </app-form-label>
                  <div class="row mb-2">
                    <div class="col-6 mx-2 mt-2">
                      <app-form-checkbox
                        [fCN]="'is_important'"
                        [fG]="shareNewsForm"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'NEWSMARKASIMPORTANT' | translate"
                        >
                      </app-form-checkbox>
                    </div>
                  </div>
                </div>
              }
              @case ('chat') {
                <div class="mb-3">
                  <app-form-label
                    [label]="'SHARESEARCHCHATROOMLABEL' | translate"
                    >
                  </app-form-label>
                  <app-form-input
                    [type]="'search'"
                    [hasErrorField]="false"
                    [placeholder]="('SHARESEARCHCHATROOMSEARCHPLACEHOLDER' | translate)"
                    [iconFront]="'search'"
                    [iconBack]="'close'"
                    [iconClickType]="'back'"
                    [fCN]="'roomSearch'"
                    [fG]="shareChatForm"
                    (iconBackClick)="filterResults()"
                    >
                  </app-form-input>
                </div>
                <div class="py-2 d-flex align-items-center justify-content-between">
                  <app-form-dropdown
                    [fG]="shareChatForm"
                    [fCN]="'filter'"
                    [dataSource]="chatFilterOptions"
                    [placeholder]="'SELECTFILTER' | translate"
                    [icon]="'filter_list'"
                    [popupWidth]="'auto'"
                    [cssClass]="'small-filter-dropdown'"
                    >
                  </app-form-dropdown>
                  @if (canCreateChat()) {
                    <div class="d-flex align-items-center">
                      <div class="dropdown">
                        <button
                          type="button"
                          class="btn btn-link p-0 text-muted"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          [attr.aria-label]="('SRMOREOPTIONS' | translate)"
                          >
                          <app-tooltip [text]="('CHATADDCHATTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'" [height]="'auto'">
                            <app-icon-badge [style]="'notification'" [icon]="'chat_add_on'" [class]="'fs-3 p-1'"></app-icon-badge>
                          </app-tooltip>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li><app-link (click)="chatCreateUserDialog = true" [title]="('CHATNEWUSERCHAT' | translate)" [style]="'dropdown'">{{ ('CHATNEWUSERCHAT' | translate) }}</app-link></li>
                          <li><app-link (click)="chatCreateGroupDialog = true" [title]="('CHATNEWGROUPCHAT' | translate)" [style]="'dropdown'">{{ ('CHATNEWGROUPCHAT' | translate) }}</app-link></li>
                        </ul>
                      </div>
                    </div>
                  }
                </div>
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    @if(selectableChatRooms().length > 0) {
                      <app-form-label [label]="'SHARESELECTCHATROOMSLABEL' | translate"></app-form-label>
                      <div class="dropdown">
                        <button
                          type="button"
                          class="btn btn-link p-0 text-muted"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          [attr.aria-label]="('SRMOREOPTIONS' | translate)"
                          >
                          <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                          @if(allRoomsSelected()) {
                            <li><app-link (click)="unselectAllRooms()" [title]="('DESELECTALL' | translate)" [style]="'dropdown'">{{ ('DESELECTALL' | translate) }}</app-link></li>
                          } @else {
                            <li><app-link (click)="selectAllRooms()" [title]="('SELECTALL' | translate)" [style]="'dropdown'">{{ ('SELECTALL' | translate) }}</app-link></li>
                          }
                        </ul>
                      </div>
                    } @else {
                      <app-form-label [label]="'SHARENOCHATROOMSFOUND' | translate"></app-form-label>
                    }
                  </div>
                  @for (room of selectableChatRooms(); track room.id; let roomIndex = $index) {
                    <div class="card selected-chat-rooms_when_share mb-2">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center flex-grow-1 ps-2">
                          <div class="e-avatar e-avatar-circle e-avatar-small me-2">
                            @if(room?.display_avatar?.path) {
                              <img
                                [ngSrc]="room?.display_avatar?.path!"
                                alt="profile_pic"
                                width="40"
                                height="40" appNgSrcImageError />
                            } @else {
                              @if (+(room?.users_count ?? 0) > 2) {
                                <app-icon-badge
                                  [style]="'default'"
                                  [icon]="'group'"
                                  [fontSize]="'fs-3'"
                                  [fontColor]="'text-white'"
                                  >
                                </app-icon-badge>
                              } @else {
                                <app-icon-badge
                                  [style]="'default'"
                                  [icon]="'perm_identity'"
                                  [fontSize]="'fs-3'"
                                  [fontColor]="'text-white'"
                                  >
                                </app-icon-badge>
                              }
                            }
                          </div>
                          <div class="lh-1">
                            <app-tooltip [text]="room?.display_name ?? ''" [opensOn]="'Auto'">
                              <app-headline [type]="'h6'" [title]="room?.display_name ?? ''" [class]="'text-muted fs-small'"></app-headline>
                            </app-tooltip>
                          </div>
                        </div>
                        <div class="checkbox-column d-flex align-items-center justify-content-center border-start p-2">
                          <app-form-checkbox [fG]="getFormArray()" [fCN]="roomIndex.toString()" [cssClass]="'pb-1'"></app-form-checkbox>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <!--@case ('mail') {
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREDESTINATIONEMAILLABEL' | translate"
                    [currentChars]="shareMailForm.controls['recipientEmail'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHAREADDEMAILPLACEHOLDER' | translate)"
                    [label]="('SHAREADDEMAILPLACEHOLDER' | translate)"
                    [errorText]="('SHAREEMAILREQUIRED' | translate)"
                    [fCN]="'recipientEmail'"
                    [fG]="shareMailForm"
                    >
                  </app-form-input>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREEMAILSUBJECTLABEL' | translate"
                    [currentChars]="shareMailForm.controls['subject'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHAREEMAILSUBJECTPLACEHOLDER' | translate)"
                    [label]="('SHAREEMAILSUBJECTPLACEHOLDER' | translate)"
                    [errorText]="('SHAREEMAILSUBJECTREQUIRED' | translate)"
                    [fCN]="'subject'"
                    [fG]="shareMailForm"
                    >
                  </app-form-input>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREEMAILMESSAGEPLACEHOLDER' | translate"
                    [currentChars]="shareMailForm.controls['message'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-textarea
                    [fCN]="'message'"
                    [fG]="shareMailForm"
                    [rows]="4"
                    [richText]="true"
                    [style]="'block'"
                    >
                  </app-form-textarea>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREEMAILMEDIATOEDIT' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-wrap gap-2">
                    <app-document-selector
                      [files]="selectableMailFiles()"
                      (selectedFiles)="shareMailForm.controls['files'].setValue($event)"
                      >
                    </app-document-selector>
                  </div>
                </div>
              }-->
              @case ('link') {
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARELINKMENUTEXT' | translate"
                    >
                  </app-form-label>
                  <input
                    class="e-input"
                    [value]="shareLink"
                    readonly
                    aria-readonly="true"
                  />
                </div>
                <div class="mt-3">
                  <app-form-button
                    [text]="'COPY' | translate"
                    [cssClass]="'e-primary'"
                    (click)="copyShareLink()"
                    >
                  </app-form-button>
                </div>
              }
              @case ('tv') {
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARETVTITLELABEL' | translate"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHARETVTITLEPLACEHOLDER' | translate)"
                    [label]="('SHARETVTITLEPLACEHOLDER' | translate)"
                    [errorText]="('SHARETVTITLEREQUIRED' | translate)"
                    [fCN]="'title'"
                    [fG]="shareTvForm"
                    >
                  </app-form-input>
                </div>
                <app-form-label
                  [label]="'SHARETVINTERNALNAMELABEL' | translate"
                  [maxChars]="30"
                  [currentChars]="shareTvForm.controls['internalNote'].value.length"
                  >
                </app-form-label>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <app-form-input
                      [placeholder]="('SHARETVINTERNALNAMEPLACEHOLDER' | translate)"
                      [label]="('SHARETVINTERNALNAMEPLACEHOLDER' | translate)"
                      [errorText]="('SHARETVINTERNALNAMEREQUIRED' | translate)"
                      [fCN]="'internalNote'"
                      [fG]="shareTvForm"
                      [maxChars]="30"
                      >
                    </app-form-input>
                  </div>
                </div>
                <div class="mb-3">
                  <app-form-label [label]="'SHARETVTEXTCONTENTLABEL' | translate"></app-form-label>
                  <app-form-textarea
                    [placeholder]="('SHARETVTEXTCONTENTPLACEHOLDER' | translate)"
                    [fCN]="'message'"
                    [fG]="shareTvForm"
                    [maxChars]="100"
                    [rows]="4"
                    >
                  </app-form-textarea>
                </div>
                <app-form-label [label]="'SHARETVCHOOSEONEMEDIALABEL' | translate"></app-form-label>
                <div class="fileFolderListContainer d-flex flex-wrap gap-3 p-2">
                  <app-document-selector
                    [files]="selectableTvFiles()"
                    [initialySelected]="false"
                    (selectedFiles)="shareTvForm.controls['files'].setValue($event)"
                    >
                  </app-document-selector>
                </div>
              }
              }
            </form>
          </div>
        }
        <!-- Share type forms -->
        <div class="d-flex justify-content-end mt-3 d-none d-md-flex">
          @switch(activeStepKey) {
            @case('news') {
              <app-form-button
                [text]="'SHARE' | translate"
                [disabled]="!canShareNews()"
                [cssClass]="'e-primary'"
                (click)="createNews()"
                >
              </app-form-button>
            }
            @case('chat') {
              <app-form-button
                [text]="'SHARETOCHATANDOPEN' | translate"
                [disabled]="shareChatForm.invalid"
                [cssClass]="'e-primary mx-3'"
                (click)="shareToChat(true)"
                >
              </app-form-button>
              <app-form-button
                [text]="'SHARETOCHAT' | translate"
                [disabled]="shareChatForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareToChat(false)"
                >
              </app-form-button>
            }
           <!-- @case('mail') {
              <app-form-button
                [text]="'SHAREBYMAIL' | translate"
                [disabled]="shareMailForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareByMail()"
                >
              </app-form-button>
            }-->
            @case('tv') {
              <app-form-button
                [text]="'PREVIEWTVSHARE' | translate"
                [disabled]="shareTvForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareTvPreview()"
                >
              </app-form-button>
              <app-form-button
                [text]="'TVSHARE' | translate"
                [disabled]="shareTvForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareTv()"
                >
              </app-form-button>
            }
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="mt-auto d-md-none col-12 d-flex justify-content-between p-2">
      <!-- Share type form completion buttons -->
      @switch(activeStepKey) {
        @case('news') {
          <app-form-button
            [text]="'SHARE' | translate"
            [disabled]="!canShareNews()"
            [cssClass]="'e-primary'"
            (click)="createNews()"
            >
          </app-form-button>
        }
        @case('chat') {
          <app-form-button
            [text]="'SHARETOCHATANDOPEN' | translate"
            [disabled]="shareChatForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareToChat(true)"
            >
          </app-form-button>
          <app-form-button
            [text]="'SHARETOCHAT' | translate"
            [disabled]="shareChatForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareToChat(false)"
            >
          </app-form-button>
        }
        <!--@case('mail') {
          <app-form-button
            [text]="'SHAREBYMAIL' | translate"
            [disabled]="shareMailForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareByMail()"
            >
          </app-form-button>
        }-->
        @case('tv') {
          <app-form-button
            [text]="'PREVIEWTVSHARE' | translate"
            [disabled]="shareTvForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareTvPreview()"
            >
          </app-form-button>
        }
      }
    </div>
  </ng-template>
</ejs-dialog>

@if (canCreateChat() && chatCreateGroupDialog) {
  <app-dialog-chat-create-group
    [visible]="chatCreateGroupDialog"
    (visibleChange)="chatCreateGroupDialog = $event"
    (chatSaved)="resetChatRooms()"
    >
  </app-dialog-chat-create-group>
}
@if (canCreateChat() && chatCreateUserDialog) {
  <app-dialog-chat-create-user
    [(visible)]="chatCreateUserDialog"
    [openCreatedChat]="false"
    (chatSaved)="resetChatRooms()"
    >
  </app-dialog-chat-create-user>
}
